import { render, staticRenderFns } from "./MoveDataModal.vue?vue&type=template&id=bf39c7a0"
import script from "./MoveDataModal.vue?vue&type=script&lang=js"
export * from "./MoveDataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports